import React from 'react';
import classNames from 'classnames';

import LogoSvg from './bc.svg';
import cn from './styles.module.scss';

export type LogoIconProps = React.SVGProps<SVGSVGElement> & {
  variant?: 'filled' | string;
  className?: string;
};

export const LogoIcon = ({ variant = '', className = '', ...props }: LogoIconProps) => (
  <LogoSvg
    className={classNames(className, { [cn.filled]: variant === 'filled' })}
    {...props}
  />
);
